"use strict";
exports.__esModule = true;
exports.Route = void 0;
var react_1 = require("react");
var context_1 = require("./context");
var useEventHandlers_1 = require("./useEventHandlers");
var defaultMapStyles = {
    fillColor: "blue",
    lineWidth: 4,
    strokeColor: "blue"
};
var Route = function (_a) {
    var _b = _a.style, style = _b === void 0 ? defaultMapStyles : _b, arrows = _a.arrows, data = _a.data, zIndex = _a.zIndex, points = _a.points, onPointerMove = _a.onPointerMove, onPointerLeave = _a.onPointerLeave, onPointerEnter = _a.onPointerEnter, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onTap = _a.onTap, draggable = _a.draggable;
    var routesGroup = (0, react_1.useContext)(context_1.HEREMapContext).routesGroup;
    var _c = (0, react_1.useState)(null), polyline = _c[0], setPolyline = _c[1];
    var line = (0, react_1.useMemo)(function () {
        var route = new H.geo.LineString();
        points.forEach(function (point) {
            var lat = point.lat, lon = point.lon;
            route.pushPoint(new H.geo.Point(lat, lon));
        });
        return route;
    }, [points]);
    (0, useEventHandlers_1.useEventHandlers)(polyline, {
        onDrag: onDrag,
        onDragEnd: onDragEnd,
        onDragStart: onDragStart,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onPointerMove: onPointerMove,
        onTap: onTap
    });
    (0, react_1.useEffect)(function () {
        if (polyline && typeof draggable === "boolean") {
            // @ts-ignore
            polyline.draggable = draggable;
        }
    }, [polyline, draggable]);
    (0, react_1.useEffect)(function () {
        polyline === null || polyline === void 0 ? void 0 : polyline.setGeometry(line);
    }, [line]);
    (0, react_1.useEffect)(function () {
        polyline === null || polyline === void 0 ? void 0 : polyline.setData(data);
    }, [polyline, data]);
    (0, react_1.useEffect)(function () {
        polyline === null || polyline === void 0 ? void 0 : polyline.setZIndex(zIndex);
    }, [polyline, zIndex]);
    (0, react_1.useEffect)(function () {
        polyline === null || polyline === void 0 ? void 0 : polyline.setStyle(style);
    }, [polyline, style]);
    (0, react_1.useEffect)(function () {
        if (routesGroup) {
            var routeLine_1 = new H.map.Polyline(line, { style: style, arrows: arrows, zIndex: zIndex, data: data });
            routesGroup.addObject(routeLine_1);
            setPolyline(routeLine_1);
            return function () {
                routesGroup.removeObject(routeLine_1);
            };
        }
    }, [routesGroup]);
    return null;
};
exports.Route = Route;
exports["default"] = exports.Route;
